import IconTrashSolid from '@/assets/icons/font_awesome/trash-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_workspace_user_delete } from '@/state/workspace/user/remote_workspace_user_delete';

import { RequestWorkspaceUserDelete } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_delete';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { useState } from 'react';

interface Props {
  item: DTO__workspace_user;
}

export const WSButtonWorkspaceUserDelete = ({ item }: Props) => {
  const dispatch = use_dispatch();

  const [isClicked, setIsClicked] = useState(false);

  const { workspace_current, current_workspace_user } = use_slice_workspace(['workspace_current', 'current_workspace_user']);

  const onClick = async () => {
    setIsClicked(true);

    let request = new RequestWorkspaceUserDelete();
    request.workspace_id = item.workspace_id;
    request.workspace_user_id = item._id;

    await dispatch(remote_workspace_user_delete(request));

    setIsClicked(false);
  };

  if (workspace_current.user_id_owner != current_workspace_user.user_id) return <></>;
  if (item.user_id == current_workspace_user.user_id) return <></>;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={'Delete user from workspace'}>
      <UI_PRIMITIVE__button_with_icon_animated
        disabled={isClicked}
        variant={'no-border-on-component'}
        iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
        iconClassNameHovered="!text-bar-foreground"
        Icon={IconTrashSolid}
        onClick={onClick}
      />
    </UI_PRIMITIVE__tooltip>
  );
};
